import { ITextLabel } from 'app/interfaces/text-label/textLabel.interface';
import React, { ReactElement } from 'react';
import ShimmeringLoading from '../ShimmeringLoading/ShimmeringLoading';
import ToolTipComponent from '../ToolTipComponent/ToolTipComponent';
import styles from './TextLabel.module.scss';

const TextLabel = function init(props: ITextLabel): React.ReactElement {
    const { bg, title, value, loading, color, ellipsis } = props;

	function renderTextLabel() : React.ReactElement {
		return (
			<div className={styles.wrapper}>
				<span
					className={bg ? styles.titleBlack : styles.title}
				>
					{title}
				</span>
				<span
					className={
						`${bg ? styles.valueBg : styles.value}
						${ellipsis ? styles.ellipsis : null}`
					}
					style={{ color }}
				>
					{value}
				</span>
			</div>
		);
	}

	// eslint-disable-next-line no-unused-vars
	function checkIfEllipsis(): ReactElement {
		if (ellipsis) {
			return (
				<ToolTipComponent content={value}>
					{renderTextLabel()}
				</ToolTipComponent>
			);
		}
		return renderTextLabel();
	}

	return (
        <div className={styles.TextLabel}>
			{loading ? <ShimmeringLoading width="90%" height="100%" />
			: (
				// <ToolTipComponent content={value}>
				// 	{renderTextLabel()}
				// </ToolTipComponent>
				checkIfEllipsis()
			)}
        </div>
    );
};

export default TextLabel;
